// Generated by ReScript, PLEASE EDIT WITH CARE


var value = {"geo_region" : {
  "pickup_polygon": [
    [
      [54.8901803, 24.9582773],
      [54.890477, 24.946707],
      [54.890472, 24.936944],
      [54.898925, 24.932057],
      [54.907378, 24.936932],
      [54.915821, 24.932057],
      [54.9155203, 24.9243231],
      [54.9218983, 24.920696],
      [54.9263615, 24.9148383],
      [54.9312046, 24.909954],
      [54.941161, 24.907678],
      [54.949614, 24.902792],
      [54.9548064, 24.8991035],
      [54.9604979, 24.895944],
      [54.966506, 24.893045],
      [54.974959, 24.888159],
      [54.9837553, 24.8856374],
      [54.9901394, 24.8816186],
      [54.9972191, 24.8790969],
      [55.004713, 24.8774169],
      [55.0063437, 24.8712491],
      [55.0091409, 24.8686202],
      [55.0115768, 24.8673436],
      [55.0225049, 24.8616145],
      [55.029028, 24.8556807],
      [55.0343003, 24.8511858],
      [55.04254, 24.849147],
      [55.050993, 24.844261],
      [55.0567852, 24.8367508],
      [55.0631643, 24.8291529],
      [55.067885, 24.8241537],
      [55.0660151, 24.8143111],
      [55.0664625, 24.8089478],
      [55.0722561, 24.8008192],
      [55.0777492, 24.7951445],
      [55.0873831, 24.8000253],
      [55.0915666, 24.802958],
      [55.0975954, 24.8066229],
      [55.1020796, 24.809976],
      [55.1088069, 24.8139822],
      [55.1156342, 24.8184707],
      [55.1249947, 24.8245676],
      [55.1293128, 24.8276482],
      [55.131061, 24.8286153],
      [55.13952, 24.8341165],
      [55.1474215, 24.8395128],
      [55.1509671, 24.8418137],
      [55.1540457, 24.8440663],
      [55.16083, 24.849138],
      [55.1655128, 24.8527824],
      [55.1739987, 24.8604223],
      [55.1804814, 24.8665085],
      [55.1850329, 24.8705699],
      [55.1876241, 24.8735916],
      [55.1887992, 24.8745496],
      [55.1936107, 24.880259],
      [55.1972851, 24.8844695],
      [55.1998487, 24.8873804],
      [55.2054743, 24.8950613],
      [55.2127319, 24.8978125],
      [55.2264546, 24.9006236],
      [55.2440978, 24.9040765],
      [55.2514678, 24.9055267],
      [55.2570072, 24.9075848],
      [55.2608713, 24.9090196],
      [55.2653233, 24.9102757],
      [55.2676456, 24.9110511],
      [55.2693986, 24.9115978],
      [55.2713661, 24.9117554],
      [55.27337, 24.912382],
      [55.2758332, 24.9127008],
      [55.2781843, 24.9134162],
      [55.2888612, 24.9150263],
      [55.2976497, 24.9164025],
      [55.30148, 24.9171162],
      [55.3053128, 24.9170224],
      [55.3122358, 24.9183293],
      [55.3147524, 24.9185283],
      [55.3183368, 24.9185822],
      [55.328014, 24.9212026],
      [55.3431202, 24.9193755],
      [55.3649195, 24.9226074],
      [55.3952167, 24.9223739],
      [55.4185613, 24.9293775],
      [55.4612393, 24.9367709],
      [55.4814303, 24.9452542],
      [55.5012142, 24.9527249],
      [55.5105711, 24.9545924],
      [55.5146909, 24.9557795],
      [55.5301416, 24.9582503],
      [55.5437065, 24.9684416],
      [55.5653472, 24.9779555],
      [55.5833805, 24.9879389],
      [55.5859621, 24.992553],
      [55.5887125, 24.9956109],
      [55.5908191, 24.9995566],
      [55.593914, 25.0052801],
      [55.5968814, 25.0100876],
      [55.5984265, 25.0135423],
      [55.599848, 25.0167945],
      [55.6007062, 25.0210218],
      [55.6040004, 25.0243433],
      [55.6070095, 25.0281976],
      [55.6083235, 25.0336939],
      [55.6116409, 25.0379838],
      [55.6122641, 25.042251],
      [55.6143291, 25.0456446],
      [55.6161215, 25.0482056],
      [55.5577928, 25.0936889],
      [55.5662042, 25.0955544],
      [55.5716974, 25.097653],
      [55.5753881, 25.0990521],
      [55.5835421, 25.1023166],
      [55.5896078, 25.1046135],
      [55.5923101, 25.1055266],
      [55.5950025, 25.1069841],
      [55.5966758, 25.1081691],
      [55.604518, 25.1119192],
      [55.6114311, 25.1155554],
      [55.622594, 25.1226745],
      [55.6357399, 25.1312503],
      [55.6445933, 25.1362502],
      [55.6609337, 25.1433409],
      [55.6817513, 25.1636015],
      [55.6858762, 25.1683885],
      [55.6884827, 25.1717104],
      [55.6896894, 25.1777411],
      [55.6936692, 25.1841703],
      [55.6360603, 25.2069633],
      [55.6315341, 25.2089956],
      [55.6261944, 25.211053],
      [55.6182582, 25.2142167],
      [55.6098555, 25.2175122],
      [55.6048215, 25.2197204],
      [55.5982078, 25.2222923],
      [55.591685, 25.224733],
      [55.5716535, 25.2326558],
      [55.5614072, 25.2363548],
      [55.5523995, 25.2397863],
      [55.5436487, 25.24329],
      [55.5363468, 25.2461795],
      [55.5297691, 25.2489087],
      [55.5211248, 25.2519357],
      [55.5113306, 25.2557584],
      [55.4994337, 25.2602212],
      [55.489386, 25.2638649],
      [55.4835439, 25.2658589],
      [55.4726575, 25.2697624],
      [55.4607544, 25.2741385],
      [55.4540985, 25.2765469],
      [55.4493307, 25.2780432],
      [55.4311683, 25.2854198],
      [55.4249145, 25.2879725],
      [55.4138428, 25.2921588],
      [55.4068906, 25.2946766],
      [55.3990921, 25.2975536],
      [55.3969683, 25.2982462],
      [55.3914594, 25.3004219],
      [55.3858646, 25.3024422],
      [55.3818843, 25.3002764],
      [55.3783547, 25.2984014],
      [55.3756996, 25.297347],
      [55.3739965, 25.2970817],
      [55.3719502, 25.2967775],
      [55.3676808, 25.2974052],
      [55.363583, 25.297897],
      [55.3575268, 25.3001307],
      [55.3546301, 25.2984193],
      [55.3517334, 25.3000058],
      [55.3489547, 25.3059181],
      [55.3481232, 25.3075552],
      [55.3481499, 25.3104338],
      [55.349566, 25.3149949],
      [55.3510567, 25.3173094],
      [55.3536366, 25.3217202],
      [55.354785, 25.3252306],
      [55.3552467, 25.3278097],
      [55.3529942, 25.3288563],
      [55.346686, 25.327162],
      [55.338243, 25.332037],
      [55.32979, 25.327162],
      [55.321352, 25.332034],
      [55.321352, 25.341784],
      [55.312903, 25.346667],
      [55.312903, 25.356416],
      [55.30445, 25.361303],
      [55.295997, 25.356428],
      [55.287554, 25.361303],
      [55.279096, 25.356425],
      [55.279091, 25.346661],
      [55.287539, 25.341778],
      [55.287539, 25.332028],
      [55.295987, 25.327145],
      [55.295987, 25.317401],
      [55.2890362, 25.3133946],
      [55.2847974, 25.3160185],
      [55.2792134, 25.30564],
      [55.2841191, 25.3007372],
      [55.2817247, 25.2994008],
      [55.279096, 25.297894],
      [55.279091, 25.288136],
      [55.270652, 25.283264],
      [55.262209, 25.288139],
      [55.253751, 25.283261],
      [55.252201, 25.2738911],
      [55.245303, 25.268628],
      [55.245298, 25.258865],
      [55.2496261, 25.252739],
      [55.253746, 25.244238],
      [55.245303, 25.239363],
      [55.245298, 25.229605],
      [55.236859, 25.224733],
      [55.228416, 25.229608],
      [55.219958, 25.22473],
      [55.219953, 25.214972],
      [55.21151, 25.210097],
      [55.211505, 25.200334],
      [55.219953, 25.19545],
      [55.219953, 25.185707],
      [55.21151, 25.180832],
      [55.211505, 25.171074],
      [55.203066, 25.166202],
      [55.194623, 25.171077],
      [55.186165, 25.166199],
      [55.18616, 25.156441],
      [55.177717, 25.151566],
      [55.177712, 25.141808],
      [55.169273, 25.136936],
      [55.16083, 25.141811],
      [55.152377, 25.136936],
      [55.143939, 25.141808],
      [55.143939, 25.151558],
      [55.135486, 25.156444],
      [55.127027, 25.151566],
      [55.127022, 25.141808],
      [55.118584, 25.136936],
      [55.110141, 25.141811],
      [55.101683, 25.136933],
      [55.101678, 25.127175],
      [55.093234, 25.122301],
      [55.093229, 25.112537],
      [55.101678, 25.107654],
      [55.101678, 25.097904],
      [55.110126, 25.093021],
      [55.110126, 25.083271],
      [55.118574, 25.078388],
      [55.118574, 25.068644],
      [55.110136, 25.063773],
      [55.101693, 25.068647],
      [55.093234, 25.06377],
      [55.093229, 25.054012],
      [55.084786, 25.049137],
      [55.084781, 25.039379],
      [55.076343, 25.034507],
      [55.067905, 25.039379],
      [55.067905, 25.049128],
      [55.059451, 25.054014],
      [55.050998, 25.04914],
      [55.042555, 25.054014],
      [55.034097, 25.049137],
      [55.034092, 25.039379],
      [55.025653, 25.034507],
      [55.01721, 25.039382],
      [55.008757, 25.034507],
      [55.000314, 25.039382],
      [54.990831, 25.0378509],
      [54.983417, 25.039382],
      [54.9747065, 25.0386286],
      [54.966521, 25.039382],
      [54.958063, 25.034504],
      [54.958058, 25.024746],
      [54.949614, 25.019871],
      [54.949609, 25.010113],
      [54.941166, 25.005239],
      [54.941161, 24.995475],
      [54.949609, 24.990591],
      [54.949609, 24.980842],
      [54.958058, 24.975959],
      [54.958058, 24.966215],
      [54.949614, 24.96134],
      [54.9475491, 24.9522824],
      [54.941171, 24.94671],
      [54.932728, 24.951585],
      [54.924275, 24.94671],
      [54.915831, 24.951585],
      [54.9044598, 24.9618067],
      [54.8901803, 24.9582773],
    ],
  ],
  "drop_polygon": [
    [
      [56.0343332, 24.8545554],
      [56.0666333, 24.7926428],
      [56.0951241, 24.7516546],
      [56.1107724, 24.7545804],
      [56.1590418, 24.7861057],
      [56.182806, 24.865014],
      [56.2752418, 24.8959476],
      [56.304477, 24.9009989],
      [56.322701, 24.9140325],
      [56.3267648, 24.9301407],
      [56.3145496, 24.9737857],
      [56.3049567, 24.9841527],
      [56.3503898, 24.9847867],
      [56.3698145, 25.0030417],
      [56.3671726, 25.0304412],
      [56.3658041, 25.0339272],
      [56.3642637, 25.0405238],
      [56.3625518, 25.0516294],
      [56.3602367, 25.0784842],
      [56.359336, 25.0819322],
      [56.3589503, 25.0888006],
      [56.3581353, 25.1084772],
      [56.3578352, 25.1217805],
      [56.3561617, 25.1455709],
      [56.3576423, 25.1608897],
      [56.360185, 25.1610715],
      [56.3588171, 25.1616286],
      [56.3580044, 25.1616934],
      [56.3580071, 25.1634674],
      [56.3658599, 25.1753465],
      [56.3582852, 25.1710327],
      [56.3584943, 25.1873142],
      [56.370548, 25.1823134],
      [56.3701564, 25.2088828],
      [56.3621499, 25.2055876],
      [56.3699363, 25.243601],
      [56.3643152, 25.244727],
      [56.3657101, 25.2516948],
      [56.3726678, 25.249827],
      [56.3743899, 25.2543247],
      [56.3744571, 25.2577571],
      [56.3674096, 25.2585418],
      [56.3688593, 25.2643721],
      [56.3708574, 25.2708117],
      [56.371599, 25.2783779],
      [56.3727852, 25.2853426],
      [56.3727776, 25.2920456],
      [56.3741469, 25.3051349],
      [56.3778784, 25.3256832],
      [56.346528, 25.2662744],
      [56.3048677, 25.2356661],
      [56.2689542, 25.2316455],
      [56.2535941, 25.2328192],
      [56.2382334, 25.2358547],
      [56.2252864, 25.2424872],
      [56.2187276, 25.2500142],
      [56.2156015, 25.2594042],
      [56.2238124, 25.2702261],
      [56.2407706, 25.283175],
      [56.2459261, 25.2941388],
      [56.2356321, 25.3158092],
      [56.2555559, 25.3423844],
      [56.282492, 25.3390144],
      [56.3094259, 25.3325365],
      [56.3457007, 25.3109723],
      [56.3601652, 25.3490021],
      [56.3551459, 25.3519656],
      [56.3506414, 25.3567905],
      [56.3490549, 25.3621195],
      [56.34867, 25.3676036],
      [56.3499159, 25.3736305],
      [56.3574054, 25.3759847],
      [56.3621098, 25.3889895],
      [56.3638965, 25.394938],
      [56.3651252, 25.400324],
      [56.3661259, 25.4051879],
      [56.3657533, 25.408036],
      [56.3638755, 25.4217143],
      [56.3642696, 25.4258411],
      [56.3648783, 25.4283982],
      [56.3627565, 25.4283004],
      [56.3612075, 25.4292882],
      [56.3605617, 25.4301745],
      [56.3598955, 25.4315236],
      [56.3593365, 25.4338416],
      [56.3590409, 25.4365771],
      [56.358917, 25.4389445],
      [56.3589128, 25.4404591],
      [56.3591039, 25.4415749],
      [56.3593807, 25.441935],
      [56.3588896, 25.4447996],
      [56.3591923, 25.4473491],
      [56.3614036, 25.4548239],
      [56.3621559, 25.4588113],
      [56.3626504, 25.4721906],
      [56.3630264, 25.4794615],
      [56.3623051, 25.4798846],
      [56.3602104, 25.4864287],
      [56.3613424, 25.4915364],
      [56.3621204, 25.4964792],
      [56.363156, 25.501577],
      [56.3649641, 25.506055],
      [56.3662574, 25.5099908],
      [56.3696165, 25.5190631],
      [56.3685066, 25.5212756],
      [56.3695853, 25.5258893],
      [56.368224, 25.531076],
      [56.3656609, 25.5359529],
      [56.3629379, 25.5343991],
      [56.3550875, 25.5500336],
      [56.3533073, 25.5621865],
      [56.3534152, 25.5734103],
      [56.3551426, 25.5830474],
      [56.3553251, 25.5925297],
      [56.3544722, 25.5951031],
      [56.3519027, 25.5965927],
      [56.3482172, 25.596689],
      [56.3460507, 25.5982685],
      [56.3442274, 25.6003125],
      [56.3426409, 25.5999108],
      [56.3386183, 25.6018338],
      [56.3350247, 25.6040663],
      [56.3338687, 25.6035629],
      [56.3328415, 25.6023242],
      [56.3299288, 25.6027106],
      [56.3279657, 25.6034833],
      [56.320574, 25.6053592],
      [56.3071686, 25.6094706],
      [56.3022785, 25.6099937],
      [56.2992767, 25.6095878],
      [56.2925866, 25.6076922],
      [56.2900213, 25.6059133],
      [56.2836051, 25.6098836],
      [56.2803647, 25.6124221],
      [56.279463, 25.6135516],
      [56.2821234, 25.6154708],
      [56.2822948, 25.6163838],
      [56.2797194, 25.6147271],
      [56.278859, 25.6157623],
      [56.2809147, 25.6179875],
      [56.2803331, 25.6190614],
      [56.2803525, 25.6201353],
      [56.2812301, 25.6207061],
      [56.2825369, 25.62089],
      [56.2807172, 25.6239088],
      [56.2789234, 25.6237937],
      [56.2736187, 25.6213577],
      [56.2707172, 25.6240294],
      [56.2696462, 25.6243295],
      [56.2671806, 25.6239138],
      [56.2658512, 25.6225256],
      [56.2657449, 25.6199574],
      [56.2626142, 25.6184194],
      [56.2622303, 25.6165912],
      [56.2634772, 25.6122476],
      [56.2676841, 25.6092245],
      [56.2737363, 25.6057369],
      [56.2632877, 25.5987662],
      [56.2376687, 25.5994194],
      [56.2209769, 25.606559],
      [56.2178994, 25.6062285],
      [56.2100644, 25.6066932],
      [56.198002, 25.6075449],
      [56.1615839, 25.6051062],
      [56.1524683, 25.6444345],
      [56.1397401, 25.6805873],
      [56.1395706, 25.693049],
      [56.1466122, 25.7209794],
      [56.1447688, 25.7423024],
      [56.1412076, 25.7521824],
      [56.1328784, 25.8074755],
      [56.132187, 25.8186587],
      [56.1450344, 25.8482571],
      [56.1542797, 25.8582327],
      [56.1547466, 25.8605741],
      [56.1482991, 25.8706649],
      [56.1515154, 25.8802361],
      [56.1557631, 25.8847102],
      [56.1639171, 25.8950918],
      [56.166578, 25.9054738],
      [56.163745, 25.914185],
      [56.1616844, 25.9197198],
      [56.1550728, 25.9324125],
      [56.1605612, 25.948034],
      [56.1644202, 25.9568311],
      [56.177121, 25.9722249],
      [56.1740285, 25.9939848],
      [56.1664106, 26.0202745],
      [56.165021, 26.0239919],
      [56.1624295, 26.0317198],
      [56.1595159, 26.0400451],
      [56.1576321, 26.0445145],
      [56.156981, 26.0488477],
      [56.1573599, 26.0530268],
      [56.155886, 26.0567582],
      [56.1548265, 26.06052],
      [56.1498716, 26.0623667],
      [56.1461538, 26.0623145],
      [56.142924, 26.0590487],
      [56.1398978, 26.0557551],
      [56.1348704, 26.0532101],
      [56.1280829, 26.0504778],
      [56.1253228, 26.0491767],
      [56.1216052, 26.0476542],
      [56.1168308, 26.0477704],
      [56.1077913, 26.051799],
      [56.1022605, 26.0518824],
      [56.0938063, 26.0495352],
      [56.0894721, 26.0490626],
      [56.0861269, 26.0476916],
      [55.9657925, 25.8312688],
      [55.9015914, 25.7504332],
      [55.8509886, 25.7296807],
      [55.8463961, 25.7293348],
      [55.7973931, 25.7218261],
      [55.7242656, 25.6930574],
      [55.7421183, 25.6522126],
      [55.611656, 25.6200218],
      [55.5776896, 25.6102695],
      [55.5574641, 25.585032],
      [55.5396827, 25.559323],
      [55.5062099, 25.5103745],
      [55.472954, 25.4601786],
      [55.4122839, 25.3901399],
      [55.3914661, 25.3808739],
      [55.3814207, 25.3772282],
      [55.3668334, 25.3655928],
      [55.3479848, 25.3286754],
      [55.3364069, 25.3268511],
      [55.328606, 25.3234745],
      [55.3276713, 25.3281662],
      [55.3250199, 25.3306856],
      [55.322311, 25.3299019],
      [55.3196392, 25.332989],
      [55.3180722, 25.3341979],
      [55.3148155, 25.3334115],
      [55.3101855, 25.3369693],
      [55.3115684, 25.3403611],
      [55.3084975, 25.3449726],
      [55.3044153, 25.3473693],
      [55.2931593, 25.3574369],
      [55.293921, 25.3518353],
      [55.2943018, 25.3485692],
      [55.2980971, 25.3472466],
      [55.3003379, 25.3427068],
      [55.2959652, 25.3395062],
      [55.2936073, 25.3372853],
      [55.2919362, 25.3304099],
      [55.2966356, 25.3285942],
      [55.3007018, 25.3248933],
      [55.3101162, 25.3180771],
      [55.3161965, 25.3171514],
      [55.3188934, 25.3193264],
      [55.319212, 25.3273963],
      [55.3210879, 25.3280176],
      [55.3229638, 25.325846],
      [55.3230924, 25.3203511],
      [55.319488, 25.311715],
      [55.3115936, 25.3077872],
      [55.3088525, 25.3011732],
      [55.2965041, 25.3065655],
      [55.2841661, 25.3142429],
      [55.281465, 25.30601],
      [55.2870509, 25.2969945],
      [55.2844921, 25.2895169],
      [55.2659901, 25.2832492],
      [55.257827, 25.2825077],
      [55.2538685, 25.2636421],
      [55.2500701, 25.2693729],
      [55.2451369, 25.2143326],
      [55.2408925, 25.213643],
      [55.2385839, 25.2163012],
      [55.2377432, 25.2209951],
      [55.2312564, 25.2235488],
      [55.22721, 25.2227549],
      [55.2252978, 25.2180619],
      [55.2290518, 25.2057605],
      [55.2225064, 25.1974973],
      [55.223104, 25.1892962],
      [55.2112595, 25.1732076],
      [55.1978788, 25.1568787],
      [55.1920626, 25.1587109],
      [55.1794136, 25.1316188],
      [55.1736942, 25.1241895],
      [55.1622249, 25.1153609],
      [55.1582665, 25.1112723],
      [55.1531068, 25.1081162],
      [55.1511786, 25.1082378],
      [55.1608818, 25.1168746],
      [55.1593456, 25.1175165],
      [55.1579899, 25.1175567],
      [55.1556218, 25.1177924],
      [55.1546621, 25.1193517],
      [55.1551613, 25.1213771],
      [55.1553172, 25.1234025],
      [55.1553711, 25.1269869],
      [55.1545667, 25.1305712],
      [55.1506614, 25.1376032],
      [55.1464983, 25.1405164],
      [55.1411333, 25.1420308],
      [55.134857, 25.1417581],
      [55.1285808, 25.1407082],
      [55.1243698, 25.1388236],
      [55.120674, 25.1364727],
      [55.1139694, 25.131149],
      [55.1104286, 25.1257096],
      [55.1075747, 25.1196485],
      [55.1071021, 25.1143653],
      [55.1078311, 25.1090821],
      [55.1109753, 25.1036187],
      [55.1136495, 25.1007761],
      [55.1170103, 25.0988661],
      [55.1204997, 25.0977333],
      [55.1247616, 25.0969113],
      [55.1300406, 25.0970563],
      [55.1340534, 25.0980615],
      [55.134633, 25.095802],
      [55.125965, 25.0925164],
      [55.12528, 25.0913861],
      [55.126485, 25.0886593],
      [55.1292383, 25.0883359],
      [55.1376628, 25.0887771],
      [55.1352855, 25.0839074],
      [55.1300162, 25.0772777],
      [55.126624, 25.0742327],
      [55.1248177, 25.0751393],
      [55.1249814, 25.0785073],
      [55.1249656, 25.080268],
      [55.1223589, 25.0836339],
      [55.1207502, 25.0835247],
      [55.1187345, 25.0808186],
      [55.1186515, 25.0796041],
      [55.1231205, 25.0757759],
      [55.1228689, 25.0734247],
      [55.123819, 25.0713844],
      [55.1221261, 25.0700647],
      [55.1175391, 25.0644707],
      [55.1057918, 25.0532819],
      [55.1025419, 25.0550774],
      [55.1013519, 25.0540738],
      [55.1019137, 25.0505261],
      [55.0992619, 25.0454525],
      [55.0857225, 25.0331271],
      [55.0816471, 25.032738],
      [55.0759021, 25.0257384],
      [55.0695925, 25.0370059],
      [55.0675748, 25.0442293],
      [55.0597623, 25.0421901],
      [55.0575266, 25.0496208],
      [55.0362321, 25.0367975],
      [55.0410223, 25.0291913],
      [55.04305, 25.0239331],
      [55.037493, 25.0199491],
      [55.0270663, 25.017891],
      [55.0177649, 25.0281086],
      [55.0117248, 25.0333484],
      [54.9955234, 25.0376058],
      [54.989043, 25.0375663],
      [54.9786569, 25.0376408],
      [54.9717898, 25.0360038],
      [54.9671715, 25.0334273],
      [54.9628965, 25.0289065],
      [54.9609559, 25.0266308],
      [54.9578473, 25.0227794],
      [54.9552355, 25.0184986],
      [54.9533536, 25.0151901],
      [54.9525017, 25.0115704],
      [54.9518408, 25.007981],
      [54.950863, 25.0029806],
      [54.9513108, 24.9992031],
      [54.9518633, 24.9966268],
      [54.9536548, 24.9927195],
      [54.9534615, 24.9898842],
      [54.9530756, 24.9801697],
      [54.9612285, 24.9787907],
      [54.9785599, 24.973544],
      [54.9823229, 24.9754986],
      [54.9857279, 24.9738063],
      [54.9836121, 24.971356],
      [54.8887762, 24.9471537],
      [54.9030395, 24.9233471],
      [54.8321624, 24.8931025],
      [54.7637237, 24.860957],
      [54.7590194, 24.8739057],
      [54.7496138, 24.8717646],
      [54.7534731, 24.8519138],
      [54.7371681, 24.8458474],
      [54.7059625, 24.8187481],
      [54.6943834, 24.8006901],
      [54.6616167, 24.8125362],
      [54.6770903, 24.8237687],
      [54.6709529, 24.832514],
      [54.6326284, 24.8063592],
      [54.6425088, 24.7902106],
      [54.6801089, 24.7828803],
      [54.6756695, 24.7732086],
      [54.647608, 24.7476214],
      [54.4386276, 24.5991458],
      [54.3363802, 24.5216918],
      [54.2246351, 24.4173097],
      [53.9666773, 24.2036551],
      [53.9108387, 24.2189564],
      [53.8479611, 24.3449042],
      [53.7497521, 24.2963861],
      [53.7268272, 24.2739086],
      [53.4785021, 24.1229777],
      [53.4422445, 24.1309003],
      [53.39802, 24.1135471],
      [53.304665, 24.1199747],
      [53.3129381, 24.100068],
      [53.2896642, 24.0903307],
      [53.2733282, 24.0946684],
      [53.2310365, 24.1095905],
      [53.2013545, 24.1494394],
      [53.1630836, 24.1845106],
      [52.976334, 24.159108],
      [52.775857, 24.1531448],
      [52.6651484, 24.1520844],
      [52.6409357, 24.1935955],
      [52.5883627, 24.2202091],
      [52.5769468, 24.1979843],
      [52.5545498, 24.1807681],
      [52.5619441, 24.1388203],
      [52.6044242, 24.0557391],
      [52.6471447, 23.9437379],
      [53.9334517, 23.5800966],
      [54.1037249, 23.5420346],
      [54.4391411, 23.5327669],
      [54.6865855, 23.516149],
      [55.0271615, 23.5229958],
      [55.2901919, 23.6658157],
      [55.4752841, 23.9412113],
      [55.4789532, 23.9478478],
      [55.4855987, 23.9558608],
      [55.4963648, 23.9623045],
      [55.5154952, 23.9734649],
      [55.5810698, 24.0041973],
      [55.6327178, 24.0294229],
      [55.7430317, 24.0699713],
      [55.7803716, 24.0564203],
      [55.7993198, 24.045897],
      [55.8168922, 24.0341193],
      [55.8435617, 24.0327674],
      [55.9059381, 24.0572752],
      [55.9580304, 24.0742898],
      [55.9857549, 24.0886252],
      [55.9569332, 24.1439891],
      [55.9530689, 24.182766],
      [55.9270543, 24.2068672],
      [55.8258119, 24.185264],
      [55.7819906, 24.2188914],
      [55.7384956, 24.2279607],
      [55.7504956, 24.2698998],
      [55.7686212, 24.277459],
      [55.7956266, 24.3144332],
      [55.8126509, 24.3451255],
      [55.8146608, 24.3508738],
      [55.8076329, 24.4100779],
      [55.8000219, 24.4335499],
      [55.7817295, 24.4624582],
      [55.7354785, 24.5731128],
      [55.7811404, 24.6173241],
      [55.772151, 24.6421511],
      [55.7884798, 24.6540637],
      [55.8133039, 24.6816553],
      [55.8108081, 24.71374],
      [55.8136671, 24.7418238],
      [55.7768488, 24.9158574],
      [55.8272713, 24.9889644],
      [55.9019898, 25.0075213],
      [55.9721993, 25.0260326],
      [56.0461859, 25.0128961],
      [56.0696166, 24.9785044],
      [56.0860102, 24.9521268],
      [56.0843728, 24.9118797],
      [56.0772074, 24.8763399],
      [56.0706952, 24.8669676],
      [56.0586909, 24.8613327],
      [56.0343332, 24.8545554],
    ],
  ],
}};

export {
  value ,
  
}
/* No side effect */
